export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="logoMark" aria-label="Siktra Sleep">
      <img src="/brand/siktra-sleep-logo-source-locked.svg" alt="Siktra Sleep" />
      {!compact && (
        <div>
          <strong>Siktra Manage</strong>
          <span>Enterprise Control Center</span>
        </div>
      )}
    </div>
  );
}
